export default {"src":"/_next/static/media/kelas-live-upcoming.032d42dc.svg","height":438,"width":1440,"blurWidth":0,"blurHeight":0};